import { ISiteInfo } from "@msteams/bridges-models-files";
import { spFolderItemSetKeyFacet } from "@ms/items-view-addon-sp-prefetch";
import { FilesPrefetchMemoryRecordService } from "@msteams/bridges-services-files-prefetch-memory-record";

export function createRootItemKey(
  siteInfo: ISiteInfo,
  inCloudStorage = false
): typeof spFolderItemSetKeyFacet.type {
  const isChannelFilesRoot = !!(
    siteInfo.rootChannelPath &&
    siteInfo.rootChannelPath === siteInfo.rootFolderPath
  );

  FilesPrefetchMemoryRecordService.getInstance().setRootRenderStatus(
    isChannelFilesRoot
  );

  return {
    webAbsoluteUrl: siteInfo.rootUrl,
    listFullUrl: siteInfo.listUrl,
    rootFolder:
      (inCloudStorage ? siteInfo.rootChannelPath : siteInfo.rootFolderPath) ||
      "",
    filterParams: siteInfo.filterParams,
    // Sorting by default on Modified Date
    sortFieldKey: "Modified"
  };
}
